module.exports = __webpack_public_path__ + "img/quote-up-square.a7c84db2.svg";